
<p-dialog class="dialog-maximized" [modal]="true" [closable]="!standalone" [maximizable]="true" [styleClass]="standalone ? 'standalone-dialog' : ''" [resizable]="false" [(visible)]="showCiscoEdge"
#myDialog (onShow)="onDialogShow(myDialog)" [style]="{ width: '100%', height: '100%' }">
    <ng-template pTemplate="header">
      <div *ngIf="standalone" class="standalone-logo-header">
        <img src="assets/img/brand/awp.png" alt="AWP" />
      </div>
      <span *ngIf="!standalone">Dettaglio Cisco Edge</span>
    </ng-template>
<div class="ml-4 mr-4">
<div *ngIf="overlayVisible()" class="page-overlay"></div>

<div id="device-menu" class="floatMenu fixed top-[45px] z-[1000]">

<p-button (click)="menu.toggle($event)" severity="primary" [raised]="true" size="small" ><fa-icon [icon]="['fas', 'ellipsis-vertical']"></fa-icon> Device Menu</p-button>
<p-menu #menu [model]="items" [popup]="true" appendTo="device-menu" />
<p-button class="ml-2" (click)="refreshData(deviceUUID)" severity="primary" [raised]="true" size="small" ><fa-icon [icon]="['fas', 'refresh']"></fa-icon> Refresh</p-button>
</div>
<br><br>
<div class="flex flex-wrap gap-2 mb-2 mt-4" #workflow> <!-- info frazionario -->
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'bank']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Frazionario</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.installation?.Frazionario}} - Fascia {{ciscoEdge()?.frazionarioDetails?.FasciaSede}}</h6>
    <h5 class="text-[0.8rem] m-0">{{ciscoEdge()?.frazionarioDetails?.Denominazione}}</h5>
    <p-skeleton *ngIf="!ciscoEdge()?.installation?.Frazionario" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'server']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Cella</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.installation?.Cella}}</h6>
    <p-skeleton *ngIf="!ciscoEdge()?.installation?.Cella" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}" [ngClass]="{'p-fieldset-danger': ((ciscoEdge()?.frazionarioDetails?.step_name?.includes('Retry')|| ciscoEdge()?.frazionarioDetails?.step_name == 'Policy Group Association') && (ciscoEdge()?.frazionarioDetails?.TaskError || ciscoEdge()?.frazionarioDetails?.WorkflowError))}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'sitemap']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Workflow</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.frazionarioDetails?.step_name}}</h6>
    <p-skeleton *ngIf="!ciscoEdge()?.frazionarioDetails?.step_name" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Installazione SDWAN</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.installation?.DataInstallazione}}</h6>
    <p-skeleton *ngIf="!ciscoEdge()?.installation?.DataInstallazione" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
      <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Migrazione SDWAN</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.installation?.DataMigrazione}}</h6>
    <p-skeleton *ngIf="!ciscoEdge()?.installation?.DataMigrazione" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
</div>
<div *ngIf="ciscoEdge()?.migrationNRD && ciscoEdge()?.migrationNRD !== null" class="flex flex-wrap gap-2 mb-2 mt-4" #workflow2> <!-- info 2 frazionario -->
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'globe']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">NRD</span>
        </div>
    </ng-template>
  <ng-container *ngIf="ciscoEdge()?.migrationNRD?.DataMigrazione; else showFrazionario">
    <fa-icon [icon]="['fas', 'check']" class="text-green-500 text-xl"></fa-icon>
  </ng-container>
    <ng-template #showFrazionario>
    <h6 class="info-card-title">-</h6>
  </ng-template>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'server']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Carrier</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.migrationNRD?.Carrier}} - {{ciscoEdge()?.migrationNRD?.Classificazione}}</h6>
    <p-skeleton *ngIf="!ciscoEdge()?.migrationNRD?.Carrier" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
      <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'phone']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Circuito</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.migrationNRD?.Circuito}} </h6>
    <p-skeleton *ngIf="!ciscoEdge()?.migrationNRD?.Circuito" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
              <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Pianificazione NRD</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.migrationNRD?.DataPianificata | date: 'yyyy-MM-dd'}}</h6>
    <p-skeleton *ngIf="!ciscoEdge()?.migrationNRD?.DataPianificata" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
           <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Migrazione NRD</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{ciscoEdge()?.migrationNRD?.DataMigrazione | date: 'yyyy-MM-dd HH:mm'}}</h6>
    <p-skeleton *ngIf="!ciscoEdge()?.migrationNRD?.DataMigrazione" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
</div>
<div class="flex flex-wrap -mx-3 inline">
<p-panel [toggleable]="true" [style]="{'padding': '0'}" class="p-panel-danger" [collapsed]="true" *ngIf="ciscoEdge()?.frazionarioDetails?.TaskError && (ciscoEdge()?.frazionarioDetails?.step_name?.includes('Retry')|| ciscoEdge()?.frazionarioDetails?.step_name == 'Policy Group Association')">
    <ng-template #header>
        <div class="flex items-center gap-2">
            <span class="font-bold">vManage Error</span>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="flex flex-wrap items-center justify-between gap-4">
            <div class="flex items-center gap-2">


            </div>
            <span class="text-surface-500 dark:text-surface-400">Updated: {{ convertDate(ciscoEdge()?.frazionarioDetails?.TaskError?.lastUpdateTime) }}</span>
        </div>
    </ng-template>

        <p-table [value]="ciscoEdge()?.frazionarioDetails?.TaskError?.activity" stripedRows  [size]="'small'">
            <ng-template pTemplate="body" let-error>
                <tr>
                    <td>{{ error }}</td>
                </tr>
            </ng-template>
        </p-table>
</p-panel>
</div>
<div class="flex flex-wrap -mx-3 inline">
<p-panel [toggleable]="true" [style]="{'padding': '0'}" class="p-panel-danger" [collapsed]="true" *ngIf="ciscoEdge()?.frazionarioDetails?.WorkflowError && (ciscoEdge()?.frazionarioDetails?.step_name?.includes('Retry') || ciscoEdge()?.frazionarioDetails?.step_name == 'Policy Group Association')">
    <ng-template #header>
        <div class="flex items-center gap-2">
            <span class="font-bold">Workflow Error</span>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="flex flex-wrap items-center justify-between gap-4">
            <div class="flex items-center gap-2">


            </div>
            <span class="text-surface-500 dark:text-surface-400">Updated: {{ convertDate(ciscoEdge()?.frazionarioDetails?.TaskError?.lastUpdateTime) }}</span>
        </div>
    </ng-template>

        <div *ngIf="ciscoEdge()?.frazionarioDetails?.WorkflowError != null">
        <div [innerHTML]="ciscoEdge()?.frazionarioDetails?.WorkflowError?.errorMessage" class="mb-4 mt-3 ml-3 mr-3"></div>
      </div>
</p-panel>
</div>
<div class="flex flex-wrap mt-2 mb-2" *ngIf="rawData().length > 0"> <!-- chart -->
  <echarts [options]="chartOption()" class="chart w-full"></echarts>
</div>
<p-skeleton styleClass="mt-2 mb-2" *ngIf="rawData().length === 0" height="400px"></p-skeleton>


<div class="flex flex-wrap -mx-3 gap-0 mb-3"> <!-- sensors -->
  <div #sensors class="flex flex-wrap -mx-3 w-full justify-center gap-[5px]">
      <div *ngFor="let sensor of sensorsList()" class="fq-card bg-fq-secondary mb-0 rounded-[1rem 1rem 1rem]">
        <div class="flex">
          <i class="{{sensor.icon}} mt-[11px] ml-3 text-fq-primary"></i>
          <div class="mr-[-7px] mt-[-1px]"> <span class="greyCard">{{sensor.label}}</span></div>
          <p-badge class="badgeRadius glow clickable" [value]="sensor.value"></p-badge>
        </div>
      </div>
    </div>

</div>



<div class="flex flex-wrap mb-2">
  <div #traffic class="flex-1 fq-card fuseqCard  ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Traffic History
        </div><div class="fq-card-body fuseqCardBody overflow-x-auto">
    <p-inputgroup class="w-full justify-end mt-2 flex-wrap"><p-inputgroup-addon>Interval</p-inputgroup-addon><select  #mySelect
       
       
        [(ngModel)]="timeRangeMode"
        (change)="onTimeRangeModeChange($event)" class="fq-form-control w-[10rem] text-center">
        <option value="1">1 Hour</option>
        <option value="3">3 Hours</option>
        <option value="6">6 Hours</option>
        <option value="12">12 Hours</option>
        <option value="24">24 Hours</option>
        <option value="168">Last Week</option>
        <option value="custom">Custom Range</option>
      </select>
    <div *ngIf="timeRangeMode === 'custom'" class="flex flex-wrap items-center gap-1 ml-2">
      <input #startDate type="date" class="fq-form-control w-[10rem]"/>
      <span class="mx-2">to</span>
      <input #endDate type="date" class="fq-form-control w-[10rem]"/>
      <button type="button" class="fq-btn fq-btn-primary ml-2" (click)="applyCustomRange(startDate.value, endDate.value)"> Apply
      </button>
    </div></p-inputgroup>
    <div class="w-full flex justify-end">
        <div class="text-start">
      Max RX: <span class="font-bold text-fq-primary">{{ maxRX() }}</span> |
      Max TX: <span class="font-bold text-fq-primary">{{ maxTX() }}</span>
    </div>
      </div>
<div *ngIf="isTrafficLoading()" class="flex justify-center items-center h-[450px]">
  <div class="inline-block w-8 h-8 border-4 border-fq-primary border-t-transparent rounded-full animate-spin text-fq-primary" role="status">
    <span class="sr-only"></span>
  </div>
</div>

<div *ngIf="!isTrafficLoading() && !hasTrafficData()" class="flex justify-center items-center text-fq-text-muted h-[450px]">
  <span>No data available</span>
</div>
<echarts
  *ngIf="!isTrafficLoading() && hasTrafficData() && chartOptionBanda()" [options]="chartOptionBanda()" class="chart w-full h-[450px] block"></echarts>
  </div>
  </div>
</div>
<div class="flex flex-wrap mt-2 mb-2">
  <div #details class="w-1/4 fq-card fuseqCard ml-1 h-full m-0 p-0">
        <div class="fq-card-header fuseqCardHeader">
            Device Details <span class="inline-flex items-center px-2 py-0.5 text-xs font-bold text-white bg-gray-500 rounded float-right mr-2">Updated: {{ciscoEdge()?.device['lastupdated']}}</span>
        </div>
        <div class="fq-card-body fuseqCardBody">
          <div class="flex flex-wrap -mx-3 gap-0 mb-2"> <!-- cpu ram -->



  <div class="flex-1 min-w-0 ml-2 mt-2" >

        <p-fieldset [style]="{'text-align': 'center'}">
           <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'microchip']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">CPU</span>
        </div>
    </ng-template>
    <p-progressBar *ngIf="avgCPU() && avgCPU() > 0" [value]="avgCPU()" styleClass="striped-progress"></p-progressBar>
    <p-skeleton *ngIf="!avgCPU() || avgCPU() === 0" height="23px"></p-skeleton>
</p-fieldset>
  </div>

  <div class="flex-1 min-w-0 mr-2 mt-2" >

        <p-fieldset [style]="{'text-align': 'center'}">
          <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'memory']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">RAM</span>
        </div>
    </ng-template>
    <p-progressBar *ngIf="avgRAM() && avgRAM() > 0" [value]="avgRAM()" styleClass="striped-progress"></p-progressBar>
    <p-skeleton *ngIf="!avgRAM() || avgRAM() === 0" height="23px"></p-skeleton>
</p-fieldset>
  </div>


        </div>
        <div class="flex flex-wrap -mx-3">
          <div class="flex-1 min-w-0 ml-2 mt-2" >
<p-fieldset [style]="{'text-align': 'center'}" (click)="visibleReboot = true" styleClass="clickable">
          <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'rotate']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Reboot</span>
        </div>
    </ng-template>
    <h5>{{ciscoEdge()?.rebootHistory?.length}}</h5>
    <p-skeleton *ngIf="!ciscoEdge()?.rebootHistory?.length" height="23px"></p-skeleton>
</p-fieldset>
</div>
<div class="flex-1 min-w-0 mr-2 mt-2">
<p-fieldset [style]="{'text-align': 'center'}" >
          <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'power-off']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Status</span>
        </div>
    </ng-template>
    <h5>{{ciscoEdge()?.device?.reachability}}</h5>
    <p-skeleton *ngIf="!ciscoEdge()?.device?.reachability" height="23px"></p-skeleton>
</p-fieldset>
</div>
        </div>
<p-table stripedRows *ngIf="ciscoEdge()?.device" [value]="deviceMap()" class="p-datatable-sm">
  <ng-template pTemplate="body" let-row>
    <tr>
      <td><b>{{row.header}}</b></td>
      <td>{{ row.value }}</td>
    </tr>
  </ng-template>
</p-table>
<p-table *ngIf="ciscoEdge() == null" class="p-datatable-sm" [value]="fakeData">
  <ng-template pTemplate="body" let-fake>
    <tr>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
    </tr>
  </ng-template>
</p-table>
</div>

  </div>
    <div class="flex-1 min-w-0 ml-1 mr-1">

        <div class="flex flex-wrap">
          <div #controllers class="flex-1 fq-card fuseqCard  ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Controllers
        </div><div class="fq-card-body fuseqCardBody mt-3 overflow-x-auto">
          <p-organization-chart [value]="orgChart()" [collapsible]="true" >
        <ng-template let-node pTemplate="person">
            <div class="flex flex-col">
                <div class="flex flex-col items-center">
                    <span class="font-bold mb-2">{{ node.data.name }}</span>
                    <span>{{ node.data.title }}</span>
                </div>
            </div>
        </ng-template>
    </p-organization-chart>
  <p-skeleton *ngIf="!orgChart() || orgChart().length === 0" height="200px"></p-skeleton>
  </div>

        </div>
        </div>
<div class="flex flex-wrap -mx-3 gap-0 mt-2">
  <div #tlocs class="flex-1 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            TLOCs
        </div>
              <div class="fq-card-body fuseqCardBody">

                <p-table [value]="ciscoEdge()?.tlocs" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Color</th>
      <th>Interface</th>
      <th>State</th>
      <th>Loss %</th>
      <th>Latency</th>
      <th>Jitter</th>
      <th>VQoE</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tloc>
    <tr>
      <td>{{ tloc['local_color'] }}</td>
      <td>{{ tloc['local_ifname'] }}</td>
      <td>{{ tloc['tloc_state'] }}</td>
      <td>{{ tloc['loss_percentage'] }}</td>
      <td>{{ tloc['latency'] }}</td>
      <td>{{ tloc['jitter'] }}</td>
      <td>{{ tloc['vqoe_score'] }}</td>
    </tr>
  </ng-template>
</p-table>
<p-skeleton *ngIf="!ciscoEdge()?.tlocs || ciscoEdge()?.tlocs.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.tlocs || ciscoEdge()?.tlocs.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.tlocs || ciscoEdge()?.tlocs.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
            <div #circuits class="flex-1 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Circuits
        </div>
              <div class="fq-card-body fuseqCardBody">
                <p-treeTable [value]="ciscoEdge()?.circuitTree" [scrollable]="true" class="p-treetable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template #header>
    <tr>
      <th>Name</th>
      <th>Health</th>
    </tr>
  </ng-template>
  <ng-template #body let-rowNode let-rowData="rowData">
    <tr [ttRow]="rowNode">
      <td>
                <p-treetable-toggler [rowNode]="rowNode" />
                {{ rowData.name }}
            </td>
      <td>{{ rowData.health || '-' }}</td>
    </tr>
  </ng-template>
</p-treeTable>
                <p-skeleton *ngIf="!ciscoEdge()?.circuitTree || ciscoEdge()?.circuitTree.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.circuitTree || ciscoEdge()?.circuitTree.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.circuitTree || ciscoEdge()?.circuitTree.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
</div>


        <div class="flex flex-wrap -mx-3 gap-0 mt-2">
            <div #bfdSessions class="flex-1 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">BFD Sessions</div>
              <div class="fq-card-body fuseqCardBody">
<p-table [value]="ciscoEdge()?.bfdSessions" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Local IP</th>
      <th>Remote IP</th>
      <th>Color</th>
      <th>State</th>
      <th>Loss %</th>
      <th>Latency</th>
      <th>Jitter</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-bfd>
    <tr>
      <td>{{ bfd['src-ip'] }}</td>
      <td>{{ bfd['dst-ip'] }}</td>
      <td>{{ bfd['color'] }}</td>
      <td>{{ bfd['state'] }}</td>
      <td>{{ bfd['loss_percentage'] || '-' }}</td>
      <td>{{ bfd['latency'] || '-' }}</td>
      <td>{{ bfd['jitter'] || '-' }}</td>
    </tr>
  </ng-template>
</p-table>
<p-skeleton *ngIf="!ciscoEdge()?.bfdSessions || ciscoEdge()?.bfdSessions.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.bfdSessions || ciscoEdge()?.bfdSessions.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.bfdSessions || ciscoEdge()?.bfdSessions.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.bfdSessions || ciscoEdge()?.bfdSessions.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.bfdSessions || ciscoEdge()?.bfdSessions.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.bfdSessions || ciscoEdge()?.bfdSessions.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
<div #controlConnections class="flex-1 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">Control Connections</div>
              <div class="fq-card-body fuseqCardBody">
<p-table [value]="ciscoEdge()?.controlConnections" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Peer Type</th>
      <th>System IP</th>
      <th>Local Color</th>
      <th>State</th>
      <th>ControllerGroup</th>
      <th>Public IP</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-conn>
    <tr>
      <td>{{ conn['peer-type'] }}</td>
      <td>{{ conn['system-ip'] }}</td>
      <td>{{ conn['local-color'] }}</td>
      <td>{{ conn['state'] }}</td>
      <td>{{ conn['controller-group-id'] }}</td>
      <td>{{ conn['public-ip'] }}</td>
    </tr>
  </ng-template>
</p-table>
<p-skeleton *ngIf="!ciscoEdge()?.controlConnections || ciscoEdge()?.controlConnections.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.controlConnections || ciscoEdge()?.controlConnections.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.controlConnections || ciscoEdge()?.controlConnections.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.controlConnections || ciscoEdge()?.controlConnections.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.controlConnections || ciscoEdge()?.controlConnections.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.controlConnections || ciscoEdge()?.controlConnections.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
        </div>
    </div>

</div>


        <div class="flex flex-wrap mt-2 mb-2" >
          <div #interfaces class="flex-1 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Interfaces
        </div><div class="fq-card-body fuseqCardBody">
                <p-table *ngIf="ciscoEdge() && ciscoEdge().interfaces" [value]="ciscoEdge()?.interfaces" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>IP</th>
      <th>Mac</th>
      <th>Admin</th>
      <th>Oper</th>
      <th>Received</th>
      <th>Sent</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-interface>
    <tr>
      <td>{{ interface.ifname }}</td>
      <td>{{ interface['ip-address'] }}</td>
      <td>{{ interface.hwaddr }}</td>
      <td>{{ interface['if-admin-status'] }}</td>
      <td>{{ interface['if-oper-status'] }}</td>
      <td tooltip="{{ interface['rx-octets'] }}" tooltipPosition="top">{{ convertBytes(interface['rx-octets']) }}</td>
      <td tooltip="{{interface['tx-octets'] }}" tooltipPosition="top">{{ convertBytes(interface['tx-octets']) }}</td>
    </tr>
  </ng-template>
</p-table>

<p-skeleton *ngIf="!ciscoEdge()?.interfaces || ciscoEdge()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.interfaces || ciscoEdge()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.interfaces || ciscoEdge()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.interfaces || ciscoEdge()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.interfaces || ciscoEdge()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.interfaces || ciscoEdge()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
            <div #_hardware class="flex-1 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Hardware
        </div><div class="fq-card-body fuseqCardBody">
                <p-table *ngIf="hardware() && hardware().length > 0" [value]="hardware()" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Descrizione</th>
      <th>Serial</th>
      <th>Part Number</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-hw>
    <tr>
      <td>{{ hw['hw-description'] }}</td>
      <td>{{ hw['serial-number'] }}</td>
      <td>{{ hw['part-number'] }}</td>
    </tr>
  </ng-template>
</p-table>
<p-skeleton *ngIf="hardware().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="hardware().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="hardware().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="hardware().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="hardware().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="hardware().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
        </div>

<div class="flex flex-wrap mt-2 mb-2">

            <div #switch class="flex-1 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Switch {{Marca()}}: {{IndirizzamentoSwitch()}}
        </div><div class="fq-card-body fuseqCardBody">
          <p-skeleton *ngIf="gigabitPorts().length === 0" height="140px"  styleClass="mt-2"></p-skeleton>
          <div  class="ml-2 mr-2 mt-2 w-[500px] text-center place-self-center">
<div class="switch-grid" *ngIf="ports3_4() && ports3_4().length > 0">
  <!-- solo 3 e 4 -->
  <div class="port-label-row">
    <div *ngFor="let port of ports3_4()" class="port-label">{{port.porta}}</div>
  </div>
  <div class="port-row">
    <div *ngFor="let port of ports3_4()" class="port-cell">
      <fa-icon [icon]="['fas', 'ethernet']" [ngClass]="port.stato == 'Enabled' ? 'up' : 'down'">
      </fa-icon>
    </div>
  </div>
  <div class="port-label-row">
    <div *ngFor="let port of ports3_4()" class="port-label">vlan: {{ port.vlan_effettiva }} - {{port.mode}}</div>
  </div>
  </div>
  </div>
                <div class="switch-grid" *ngIf="gigabitPorts() && gigabitPorts().length > 0">
  <!-- Etichette numeriche -->
  <div class="port-label-row">
    <div *ngFor="let i of firstArray()" class="port-label">{{ i }}</div>
  </div>
  <div class="port-row">
    <div *ngFor="let port of gigabitPorts().slice(0,firstArray().length)" class="port-cell">
      <fa-icon [icon]="['fas', 'ethernet']" [ngClass]="port.stato" pTooltip="{{ getTooltip(port) }}" tooltipPosition="top">
      </fa-icon>
    </div>
  </div>

  <!-- Seconda riga -->

  <div class="port-row">
    <div *ngFor="let port of gigabitPorts().slice(firstArray().length,gigabitPorts().length)" class="port-cell">
      <fa-icon [icon]="['fas', 'ethernet']" [ngClass]="port.stato" pTooltip="{{ getTooltip(port) }}" tooltipPosition="top">
      </fa-icon>
    </div>
  </div>
  <div class="port-label-row">
    <div *ngFor="let i of secondArray()" class="port-label">{{ i }}</div>
  </div>
</div>

</div>
            </div>
        </div>


        <fq-dialog-nav #speedtest [sections]="detailSections" [(active)]="detailTab" variant="pill" enclosed>
          <div *ngIf="detailTab === 'tasks'" class="flex flex-wrap">
            <div #tasks class="flex-1 fq-card fuseqCard m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            vManage Tasks
        </div><div class="fq-card-body fuseqCardBody">
                <p-table *ngIf="ciscoEdge() && ciscoEdge().tasks" [value]="ciscoEdge()?.tasks" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Start Time</th>
      <th>Task</th>
      <th>Status</th>
      <th>Last Activity</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-task>
    <tr>
      <td>{{ (task.Payload && task.Payload['startTime'] ? convertDate(task.Payload['startTime']) : task.Create_Date) | date: 'yyyy-MM-dd HH:mm' }}</td>
      <td>{{ task.Task }}</td>
      <td>{{ task.Status }}</td>
      <td>{{ task.Payload && task.Payload['currentActivity'] ? task.Payload['currentActivity'] : task.Payload?.data ?  task.Payload.data[0] ? task.Payload.data[0]?.currentActivity : '' : '' }}</td>
      <td><p-button icon="pi pi-cog" severity="primary" rounded text (click)="showTaskDialog(task)" /></td>
    </tr>
  </ng-template>
</p-table>
<p-skeleton *ngIf="!ciscoEdge()?.tasks || ciscoEdge()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.tasks || ciscoEdge()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.tasks || ciscoEdge()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.tasks || ciscoEdge()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.tasks || ciscoEdge()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!ciscoEdge()?.tasks || ciscoEdge()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
        </div>





          <div *ngIf="detailTab === 'speedtest-new'" class="flex flex-wrap">
            <app-speedtest-history-table class="w-full" [frazionario]="ciscoEdge()?.installation?.Frazionario"></app-speedtest-history-table>
          </div>
          <div *ngIf="detailTab === 'speedtest-old'" class="flex flex-wrap">
            <speed-test [fraz]="ciscoEdge()?.installation?.Frazionario" class="w-full ml-[0.2rem] pr-[0.2rem]"></speed-test>
          </div>
        </fq-dialog-nav>
      </div>
    </p-dialog>





<p-dialog header="{{dialogTask?.Task}}" [(visible)]="visible" [modal]="true" [style.width]="'50rem'" [style.padding]="'unset'">
    <p-table [value]="dialogTask?.activity_data" stripedRows  [size]="'small'" [style]="{'margin-bottom': '1rem'}">
        <ng-template pTemplate="body" let-activity>
            <tr>
                <td>{{ activity }}</td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
        <tr>
            <td colspan="1">No data for this task.</td>
        </tr>
    </ng-template>
    </p-table>
</p-dialog>
<p-dialog header="Reboot History" [(visible)]="visibleReboot" [modal]="true" [style.width]="'50rem'" [style.padding]="'unset'">
    <p-table *ngIf="ciscoEdge() && ciscoEdge().rebootHistory" [value]="ciscoEdge()?.rebootHistory" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="body" let-reboot>
    <tr>
      <td>{{ convertDate(reboot['reboot_date_time-date']) }}</td>
      <td>{{ reboot.reboot_reason }}</td>
    </tr>
  </ng-template>
</p-table>
</p-dialog>
